import React from 'react';
import {Button} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function HelpButton(props){    
  const { t } = useTranslation();
    return(
        <Button variant="secondary" size="sm" className="fixed-help-button" onClick={()=>props.showHelpModal(true)}>
            {t("common.help")} <i className="fas fa-question-circle"></i>
        </Button>
    )
}

export default HelpButton;